import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  useMediaQuery,
} from '@material-ui/core';
import { DarkTheme, RedactedLogo, RedactedR } from '@redacted/react-components';
import Signup from './Pages/Signup';
import FileNotFound from './Pages/404';
import ServerError from './Pages/500';
import SignupSuccess from './Pages/204';

function App() {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const maxBreakpoint = 'lg';
  const maxWidth = DarkTheme.breakpoints.values[maxBreakpoint];
  return (
    <Container
      disableGutters
      maxWidth="false"
      style={{ height: '100vh', overflow: 'hidden' }}
    >
      <Box style={{
        position: 'absolute',
        left: '24px',
        top: '31px',
      }}
      >
        <RedactedLogo
          expanded
          width={156}
          height={32}
        />
      </Box>

      <Grid
        container
        style={{
          height: '100%',
          overflow: 'hidden',
        }}
      >
        {!isSmallScreen && (
          <Grid
            item
            sm
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item>
              {/* NOTE: using manupulation of font size to preserve svg ratio 200x183 */}
              <Box
                fontSize="42vw"
                lineHeight="0.915em"
                width="1em"
                height="0.915em"
                margin="0 auto"
                maxWidth={maxWidth * 0.5}
              >
                <RedactedR width="100%" height="100%" />
              </Box>
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs
          container
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          style={{
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <Grid
            item
            alignItems="center"
            style={{
              height: '100%',
              overflow: 'auto',
              backgroundColor: isSmallScreen
                ? 'initial'
                : DarkTheme.colours.pacificBlue,
              maxWidth: isSmallScreen
                ? '100%'
                : '700px',
              display: 'flex',
            }}
          >
            <Switch>
              <Route exact path="/" component={Signup} />
              <Route exact path="/500" component={ServerError} />
              <Route exact path="/204" component={SignupSuccess} />
              <Route path="*" component={FileNotFound} />
            </Switch>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withRouter(App);
